import { render, staticRenderFns } from "./deletesendcommand.vue?vue&type=template&id=b384088e&"
import script from "./deletesendcommand.vue?vue&type=script&lang=ts&"
export * from "./deletesendcommand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "deletesendcommand.vue"
export default component.exports